export default "__VITE_ASSET__d30fdfec__"